import React from 'react';
import { View, StyleSheet } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { Theme } from '../../utils/theme';

interface LogoProps {
  size?: number;
  color?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 24, 
  color = Theme.colors.primary 
}) => {
  // Original SVG viewBox is "0 0 50 51"
  const aspectRatio = 50 / 51;
  const width = size;
  const height = size / aspectRatio;

  return (
    <View style={[styles.container, { width, height }]}>
      <Svg 
        width={width} 
        height={height} 
        viewBox="0 0 50 51" 
        fill="none"
      >
        <Path 
          d="M49.786 21.8108L46.4363 15.0249C45.8812 13.7214 44.405 13.7044 43.0866 14.2548L28.3957 21.6424C26.2559 22.536 24.0741 22.536 21.9355 21.6424L6.76609 14.0383C5.45003 13.4878 3.99417 13.962 3.4403 15.2655L0.162358 22.268C-0.39152 23.5704 0.545101 25.0889 1.86115 25.637L13.7048 31.5566C16.7854 32.8426 17.4051 34.8955 17.6287 38.1982L17.868 48.0162C17.9639 49.4274 18.7293 51 20.1889 51L29.7595 51C31.219 51 32.0804 49.5081 32.0804 48.0162L32.4393 37.38C32.7264 33.7941 34.8481 32.2376 38.3252 30.7865L48.4701 25.4925C49.7861 24.9444 50.3411 23.1132 49.786 21.8108Z" 
          fill={color}
        />
        <Path 
          d="M33.6407 8.9276C33.6407 13.8584 29.763 17.8552 24.9793 17.8552C20.1966 17.8552 16.3179 13.8584 16.3179 8.9276C16.3179 3.9968 20.1966 -2.47955e-05 24.9793 -2.47955e-05C29.763 -2.47955e-05 33.6407 3.9968 33.6407 8.9276Z" 
          fill={color}
        />
      </Svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default Logo;



